var components
try {
  components = {
    uBadge: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-badge/u-badge" */ "uview-ui/components/u-badge/u-badge.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([
    _vm.$u.addStyle(_vm.itemStyle),
    {
      flex: _vm.scrollable ? "" : 1,
    },
  ])
  var l0 = _vm.__map(_vm.list, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var s1 = _vm.__get_style([_vm.textStyle(index)])
    return {
      $orig: $orig,
      s1: s1,
    }
  })
  var g0 = _vm.$u.addUnit(_vm.lineWidth)
  var g1 = _vm.$u.addUnit(_vm.lineHeight)
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        l0: l0,
        g0: g0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }